import Vue from 'vue'
import App from './App.vue'
import '@/plugins'
import router from './router'
import store from './store'
import '@/core/filters'
import '@/assets/styles/main.scss'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
